import { Box, Breakpoint, Button, Dialog, SxProps, Theme, Typography } from '@mui/material';
import { BsX } from 'react-icons/bs';
import { pdfjs } from 'react-pdf';
import { File } from 'react-pdf/dist/cjs/shared/types';

import PDFReader from '../PDFReader';

// TODO: Jest issue (Cannot use 'import.meta' outside a module) use commenting to make it work for tests
// if (isTestingWithJest()) {
//   pdfjs.GlobalWorkerOptions.workerSrc =
//     '/node_modules/pdfjs-dist/build/pdf.worker.min.js'
// } else {
//   pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//     'pdfjs-dist/build/pdf.worker.min.js',
//     import.meta.url
//   ).toString()
// }
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;

type ViewPDFModal = {
    file: File;
    isModalOpen: boolean;
    setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    title: string;
    dialogStylesSX?: SxProps<Theme>;
    maxWidth?: false | Breakpoint;
    fileURL?: string;
    fileName?: string;
};

const ViewPDFModal = ({
    file,
    isModalOpen,
    setIsModalOpen,
    title,
    dialogStylesSX,
    maxWidth = 'lg',
    fileURL,
    fileName = null,
}: ViewPDFModal) => {
    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const HeadingComponent = () => {
        return (
            <Box
                sx={{
                    background: 'linear-gradient(90deg, #FF8008, #FFC837)',
                    height: '82px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '24px',
                }}
            >
                <Typography color="white" variant="h2">
                    {title}
                </Typography>
                <Button
                    variant="outlined"
                    startIcon={<BsX width="24px" height="24px" />}
                    onClick={handleCloseModal}
                    sx={{
                        color: '#F39E4E',
                        minWidth: '32px !important',
                        width: '32px',
                        height: '32px',
                        padding: '0px',
                        borderRadius: '50%',
                        backgroundColor: 'white',
                        border: '1px solid #F39E4E',
                        '& span': {
                            marginRight: '0px',
                            marginLeft: '0px',
                        },
                        '&:hover': {
                            backgroundColor: '#eee !important',
                        },
                        boxShadow: 'none',
                    }}
                />
            </Box>
        );
    };

    const FileNameSection = () => {
        return (
            <Box
                sx={{
                    background: 'white',
                    height: '52px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start',
                    padding: '24px',
                }}
            >
                <Typography>{fileName ?? file?.name ?? 'Statement #123123'}</Typography>
            </Box>
        );
    };

    return (
        <Dialog
            open={isModalOpen}
            onClose={handleCloseModal}
            aria-labelledby="view-pdf-modal"
            sx={{
                '& .MuiDialog-paper': {
                    width: '100%',
                    height: '100%',
                    padding: '0px',
                },
                ...dialogStylesSX,
            }}
            maxWidth={maxWidth}
        >
            <HeadingComponent />
            <FileNameSection />

            <PDFReader pdfFile={file} fileURL={fileURL} />
        </Dialog>
    );
};

export default ViewPDFModal;
